import React from "react";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

const CustomWidthTooltip = ({ toolTipClass = "smallToolTip", ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: toolTipClass }}
    arrow={true}
    placement="top"
  />
);

export default CustomWidthTooltip;
CustomWidthTooltip.propTypes = {
  toolTipClass: PropTypes.string,
}